import React from 'react';
import { Seo } from '../components/seo/Seo';
import { CV_CONFIG, CV_HEADER } from '../config/cvConfig';

// Renders the CV from CV_CONFIG (data-driven). Entries with an `href` render as an external
// link so visitors can follow the reference.
export const CvPage = () => (
    <section className="mx-auto max-w-prose">
        <Seo title="CV" canonicalPath="/cv" description="Curriculum vitae of Dragan Strukelj — education, exhibitions, publications, and private collections." />
        <div className="mb-6 text-eyebrow uppercase tracking-nav text-tone-800">CV</div>

        <header className="mb-8">
            <h1 className="text-title text-ink">{CV_HEADER.name}</h1>
            {CV_HEADER.lines.map((line, i) => (
                <p key={i} className="text-body text-tone-900">
                    {line}
                </p>
            ))}
        </header>

        <div className="flex flex-col gap-7">
            {CV_CONFIG.map((group) => (
                <div key={group.heading}>
                    <h2 className="mb-3 border-b border-tone-200 pb-2 text-meta uppercase tracking-nav text-ink">
                        {group.heading}
                    </h2>
                    <ul className="flex flex-col gap-2">
                        {group.entries.map((entry, i) => (
                            <li key={i} className="text-body text-tone-900">
                                {entry.href ? (
                                    <a
                                        href={entry.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="border-b border-tone-300 text-ink hover:border-ink motion-safe:transition-colors"
                                    >
                                        {entry.primary}
                                    </a>
                                ) : (
                                    <span className="text-ink">{entry.primary}</span>
                                )}
                                {entry.secondary && <span className="italic"> — {entry.secondary}</span>}
                                {entry.year && <span className="text-tone-800"> · {entry.year}</span>}
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    </section>
);
